import { expVal, expValEquals } from '@confluence/feature-experiments';
import { StatsigConfigurations } from '@confluence/statsig-configurations/entry-points/StatsigConfigurations.ts';
import { preloadContentTypesHeader } from '@confluence/content-types-header/entry-points/preloadContentTypesHeader.js';
import { preloadSpaceViews } from '@confluence/space-views/entry-points/preloadSpaceViews.ts';
import { preloadShortcutsSmartLinks } from '@confluence/space-shortcuts/entry-points/preloadShortcutsSmartLinks.ts';
import { preloadSideNavigation } from '@confluence/side-navigation/entry-points/preloadSideNavigation.ts';
import { preloadSpaceGuestList } from '@confluence/space-guest-list/entry-points/preloadSpaceGuestList.ts';
import { preloadDatabaseData } from '@confluence/confluence-databases/entry-points/preloadDatabaseData.ts';
import { createDataFetcherForSuspense } from '@confluence/query-preloader-tools/entry-points/dataFetcherForSuspense.ts';
import { waitForAllReturnWhenError } from '@confluence/query-preloader-tools/entry-points/waitForAllReturnWhenError.ts';
import { getPreloaderFnContext } from '@confluence/query-preloader-tools/entry-points/preloaderFnContext.ts';
import type { RouteMatch } from '@confluence/route/entry-points/Route.ts';
import { preloadShareAndRestrictButtonQuery } from '@confluence/share-and-restrict-dialog/entry-points/preloadShareAndRestrictButtonQuery.ts';
export const preloadDatabaseRoute = async (
	match: RouteMatch,
	_url: string,
	isTransition: boolean = false,
): Promise<void | any[] | Error[]> => {
	const { isLicensed } = getPreloaderFnContext();
	const tasks: Promise<any>[] = [];
	const { spaceKey, contentId } = match.params;

	// eslint-disable-next-line check-react-ssr-usage/no-react-ssr
	if (process.env.REACT_SSR) {
		const preloadNavigation = () => {
			const navTasks: Promise<any>[] = [
				preloadSideNavigation(spaceKey),
				!StatsigConfigurations.isKillSwitchOn('confluence_space_nav_affordances_frag_reader') &&
				expVal('confluence_exp_space_nav_contract', 'isEnabled', false)
					? Promise.resolve()
					: preloadSpaceGuestList(spaceKey),
			];

			if (
				StatsigConfigurations.isKillSwitchOn('confluence_space_nav_core_frag_reader') ||
				!expVal('confluence_exp_space_nav_combined_links', 'isEnabled', false)
			) {
				navTasks.push(preloadShortcutsSmartLinks(spaceKey));
			}

			return navTasks;
		};
		if (expValEquals('confluence_react_streaming_all_routes', 'isEnabled', true)) {
			tasks.push(createDataFetcherForSuspense('side-navigation', preloadNavigation));
		} else {
			tasks.push(...preloadNavigation());
		}
	} else if (!isTransition) {
		tasks.push(preloadSpaceViews(spaceKey, isLicensed));
	}

	tasks.push(preloadContentTypesHeader(contentId));
	// (No need to call preloadPageRestrictionsQuery() here; the item's restriction data will be
	//  loaded by preloadDatabaseData() below)

	// Unified Share and Restrict Button
	tasks.push(preloadShareAndRestrictButtonQuery(contentId));

	tasks.push(preloadDatabaseData(spaceKey, contentId));

	return waitForAllReturnWhenError(tasks);
};
